import React, { FC } from 'react'

interface SpacerProps {
  style?: React.CSSProperties
  className?: string
}

const Spacer: FC<SpacerProps> = ({ style, className }) => (
  <div className={className} style={{ ...style }} />
)

export default Spacer
